import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import * as moment from 'moment';
import { CorporateService } from 'src/app/component/corporate-user/corporate-service/corporate-service';
import { LevelOfServiceService } from 'src/app/component/level-of-service/service/level-of-service.service';
import { ServiceAreasService } from 'src/app/component/service-areas/service-areas-service/service-areas.service';
import { SharedDataService } from 'src/app/service/shared-service/shared-data.service';
import { sweetAlert, sweetAlertWithInput } from 'src/app/utils/swal';
import { AssigTripsService } from '../../assigntrips-service/assigntrips-service';
import { getDistanceFromLatLon, hasOvertimeViolation } from 'src/app/utils/utils.common';
import { StaffService } from 'src/app/component/staffs/staff-service/staff.service';
import { GoogleMap } from '@angular/google-maps';
import { MenuService } from 'src/app/component/shared/layout/menu-service/menu.service';

@Component({
  selector: 'app-planner-buckets',
  templateUrl: './planner-buckets.component.html',
  styleUrls: ['./planner-buckets.component.css']
})
export class PlannerBucketsComponent implements OnInit {
  @Input() wrapper;
  @ViewChild('timer', { static: false }) timer;
  @ViewChild(GoogleMap, { static: false }) googleMap: GoogleMap;


  @Output() _getLevelOfService = new EventEmitter<any>();
  @Output() _getSpaceTypes = new EventEmitter<any>();
  @Output() _getCorporates = new EventEmitter<any>();
  @Output() _getServiceAreas = new EventEmitter<any>();
  @Output() _getStaff = new EventEmitter<any>();
  @Output() _getAllTrips = new EventEmitter<any>();
  @Output() _getDrivers = new EventEmitter<any>();
  @Output() _processTrip = new EventEmitter<any>();

  drivers = [];
  trips = [];
  compatibleTrips = {};
  staff = [];
  date;
  algorithmType = false;

  preSpaceTypes = {};
  preLevelOfServices = {};
  preServiceAreas = {};
  serviceAreasList = [];
  preCooperates = {};
  selectedDriver = '';
  selectedDrivers = '';
  selectedDriverDetails;
  selectedDriverTrips = [];
  timeZone;
  user;
  isMakeLiveForAll = false;
  search;
  isSorting = false;
  isLivePrediction = true;
  selectedServiceArea;
  selectedStationManager;
  filteredTrips = [];
  filteredCompatibleTrips = {};
  stationManagerList = []
  filteredDrivers = [];
  isRdispatcher = false;
  isShowAllTrips = false;
  todayDate;
  skip = 0;
  preDrivers = {};
  duration = 30 * 1000; // 10 seconds
  isTimerEnabled = false
  showSlideFilterLoad = false;
  latitude: number;
  longitude: number;
  zoom: number = 12;
  showMap = false;
  isReady = false;
  shifts = {};
  userRole;

  constructor(
    private levelOfServiceService: LevelOfServiceService,
    private serviceArea: ServiceAreasService,
    private corporateService: CorporateService,
    private sharedDataService: SharedDataService,
    private assignTripService: AssigTripsService,
    private staffService: StaffService,
    private menuService: MenuService
  ) { }

  ngOnInit() {
    this.getUser();
  }

  getUser() {
    this.sharedDataService
      .getUser()
      .subscribe(async data => {
        if (data) {
          this.timeZone = data.timeZone;
          this.user = data;
          this.todayDate = moment().tz(this.timeZone).startOf('day').toISOString();
          setTimeout(() => {
            this._getLevelOfService.emit();
            this._getSpaceTypes.emit();
            this._getCorporates.emit();
            this._getServiceAreas.emit();
            this._getStaff.emit();
            this.getDriverEmit();
            this.isReady = true;
          }, 500);
          this.filterTrips();
          if (this.user.sRoles && this.user.sRoles === "rdispatcher") {
            this.selectedStationManager = [this.user.sId];
            this.isRdispatcher = true;
          }
          if (this.user && this.user.roles) {
            if ((typeof this.user.roles) === 'string') {
              if(this.user.sRoles) {
                this.userRole = this.menuService.getUserRoleTitle(this.user.sRoles);
              } else {
                this.userRole = this.menuService.getUserRoleTitle(this.user.roles);
              }
            } else if ((typeof this.user.roles) === 'object') {
              this.userRole = this.menuService.getUserRoleTitle(this.user.roles[0]);
            }
          }
        }
      });
  }

  getAllTrips(apiResponse) {
    if (apiResponse && apiResponse.length) {
      if (this.isTimerEnabled) {
        this.timer.start();
      }
      for (const item of apiResponse) {
        if (['unassigned', 'pending'].includes(item.status)) {
          this.trips.push(item);
        }
        if (['hanging', 'offered'].includes(item.status)) {
          const driverId = item.driver;
          if (!this.compatibleTrips[driverId] && this.preDrivers) {
            this.compatibleTrips[driverId] = {
              driver: this.preDrivers[driverId],
              trips: []
            };
          }
          this.compatibleTrips[driverId].trips.push(item);
        }

      }
      this.filteredTrips = this.trips;
      this.filteredCompatibleTrips = JSON.parse(JSON.stringify(this.compatibleTrips));

    } else {

      this.trips = apiResponse.trips || [];
      this.compatibleTrips = apiResponse.compatibleTrips || [];
      this.drivers = apiResponse.drivers || {};
      this.staff = apiResponse.staff || [];
      this.algorithmType = apiResponse.algorithmType;
      this.filteredTrips = apiResponse.trips || [];
      this.filteredDrivers = apiResponse.drivers || [];
      this.filteredCompatibleTrips = JSON.parse(JSON.stringify(apiResponse.compatibleTrips || []));
    }
    this.filterTrips();

  }

  getTripsEmit() {
    this.selectedDriverDetails = '';
    this.filteredTrips =[];
    this.filteredCompatibleTrips = {};
    this.trips = [];
    this.compatibleTrips = {};
    let jobStatuses = ['hanging', 'offered', 'pending'];

    const payload = {
      isShowAllTrips: this.isShowAllTrips,
      status: 'manifest',
      date: this.todayDate,
      skip: this.skip,
      jobStatuses
    };
    this._getAllTrips.emit(payload);
  }

  onDateChange(evt) {
    this.getTripsEmit();
  }
  getDriverEmit() {
    let endPoint = '?skipFleet=true';

    if (this.selectedServiceArea && this.selectedServiceArea.length) {
      endPoint = '?skipFleet=true&serviceAreas=' + this.selectedServiceArea.toString();
    }

    const data = {
      endPoint: endPoint,
      userId: this.user._id
    }
    this._getDrivers.emit(data);
  }

  getDriverList(apiRespone) {
    this.drivers = apiRespone || [];
    this.filteredDrivers = this.drivers || [];
    this.preDrivers = apiRespone.reduce((obj, item) => (obj[item._id] = item, obj), {});
    this.getTripsEmit();
  }


  getShifts(apiRespone) {
    this.shifts = apiRespone;
  }

  currentDayShift(driverId) {
      const currentDay = moment().tz(this.timeZone).day();
      if (driverId && this.shifts && this.shifts[driverId] && this.shifts[driverId].shifts) {
        let shift = this.shifts[driverId].shifts.find(shift => shift.day === currentDay);
        return shift;
      } else {
        return {};
      }
    }

  getCorporate(apiResponse) {
    this.preCooperates = apiResponse.reduce((obj, item) => (obj[item._id] = item, obj), {});
  }

  getLevelOfService(apiResponse) {
    this.preLevelOfServices = apiResponse.reduce((obj, item) => (obj[item._id] = item, obj), {});
  }

  getSpaceTypes(apiResponse) {
    this.preSpaceTypes = apiResponse.reduce((obj, item) => (obj[item._id] = item, obj), {});
  }

  getStaffList(apiResponse) {
    if (this.isRdispatcher) {
      this.stationManagerList = apiResponse.filter(staff => staff._id === this.user.sId);
    } else {
      this.stationManagerList = apiResponse.filter(staff => ["mdispatcher", "mcallcenter", "rdispatcher"].includes(staff.roles));
    }
  }

  getServiceAreas(apiResponse) {
    this.serviceAreasList = apiResponse;
    this.preServiceAreas = apiResponse.reduce((obj, item) => (obj[item._id] = item, obj), {});
  }

  async removeTrip(assign, key) {
    if (this.compatibleTrips && this.compatibleTrips[key]) {
      const idx = this.compatibleTrips[key].trips.findIndex(t => t._id === assign._id);
      if (idx > -1) {
        this.compatibleTrips[key].trips.splice(idx, 1);
      }
    }
    this.filteredCompatibleTrips = JSON.parse(JSON.stringify(this.compatibleTrips));
    if (this.trips) {
      this.trips.push(assign);
    }
    this.filteredTrips = [...this.trips];

    this._processTrip.emit({
      _id: assign._id,
      status: 'unassigned',
      jobStatus: 'pending'
    });
    this.selectedDriver = ''
    this.filterTrips();

  }

  async assignTrip(assign) {
    if (!this.selectedDriver) return;
    let findDriver = await this.filteredDrivers.find(d => d._id === this.selectedDriver);
    let isOvertimeViolation = false;
    if (this.user.isManagerAuthorization && !['Restricted (RM,SM,ASM)', 'Dispatcher Manager', 'Full Access'].includes(this.userRole)) {
      isOvertimeViolation = hasOvertimeViolation(assign, findDriver.shifts, this.todayDate, this.timeZone);
    }

    let overTimeReason = '';
    if (isOvertimeViolation) {
      const result = await sweetAlertWithInput(
        "Alert",
        `${findDriver.displayName} has exceeded the allowed working hours. Are you sure you want to assign this trip?`,
        "warning",
        "Yes, Assign",
        "No",
        true,
        "Min. 10 characters.",
        isOvertimeViolation,
        this.user
      );
      if (result.value) {
        overTimeReason = result.value.note
      } else {
        return;
      }
    }

    assign.status = 'offered';

    if (this.compatibleTrips) {
      if (this.compatibleTrips[this.selectedDriver]) {
        this.compatibleTrips[this.selectedDriver].trips.push(assign);
      } else {
        // Create a new bucket for the this.selectDriver if it doesn't exist
        this.compatibleTrips[this.selectedDriver] = {
          driver: this.drivers.find(d => d._id === this.selectedDriver),
          trips: [assign]
        };
      }
    }

    const findTripIndex = this.trips.findIndex(t => t._id === assign._id);
    if (findTripIndex > -1) {
      this.trips.splice(findTripIndex, 1);
    }
    this.filteredCompatibleTrips = JSON.parse(JSON.stringify(this.compatibleTrips));
    this.filteredTrips = [...this.trips];

    this._processTrip.emit({
      _id: assign._id,
      status: 'offered',
      jobStatus: 'offered',
      driver: this.selectedDriver,
      overTimeReason: overTimeReason
    });


    this.selectedDriver = '';
    this.filterTrips();
  }

async checkPossibility() {
  for (const driverId in this.filteredCompatibleTrips) {
    const driverTripsPair = this.filteredCompatibleTrips[driverId];
    const driver = driverTripsPair.driver;

    let lastTrip: any = null;
    if (driver && driver.startingPointAddress) {
      lastTrip = {
        coords: [
          driver.startingPointAddress.longitude,
          driver.startingPointAddress.latitude,
        ],
        ...driver
      };
    }

    for (let i = 0; i < driverTripsPair.trips.length; i++) {
      const item = driverTripsPair.trips[i];

      if (!lastTrip) {
        lastTrip = { ...item };
        continue;
      }

      let result;
      if (lastTrip.coords && lastTrip.coords.length) {
        result = await this.calculateDistance(
          lastTrip.coords[1], lastTrip.coords[0],
          item.jobOriginLatitude, item.jobOriginLongitude
        );
      } else {
        result = await this.calculateDistance(
          lastTrip.jobDestinationLatitude, lastTrip.jobDestinationLongitude,
          item.jobOriginLatitude, item.jobOriginLongitude
        );
      }

      // Assign back to the original array
      driverTripsPair.trips[i].milesToPickup = result.distance;
      driverTripsPair.trips[i].minutesToPickup = parseInt(result.duration);

      lastTrip = driverTripsPair.trips[i];
    }
  }

  console.log(this.filteredCompatibleTrips);
  this.filterDriverMainTrips();
}



  selectDriver(evt) {
    if (evt) {
      this.selectedDriver = evt
    }
  }

  async calculateDistance(lat1, lon1, lat2, lon2) {
    let resutl;
    if (this.algorithmType && this.algorithmType === true) {
      resutl = await this.calculateDistanceWithGIS(lat1, lon1, lat2, lon2);
    } else {
      resutl = await new Promise((resolve) => { resolve(getDistanceFromLatLon(lat1, lon1, lat2, lon2)) });
    }
    return resutl;
  }

  async calculateDistanceWithGIS(lat1, lon1, lat2, lon2) {
    const res: any = await this.assignTripService.getRoutingDistance(lat1, lon1, lat2, lon2).toPromise();
    const segments: any = res.features[0].properties.segments;
    return {
      distance: (segments[0].distance / 1609),
      duration: (segments[0].duration / 60)
    };
  }


  sortPriorityWise() {
    this.isSorting = !this.isSorting;

    this.filterDriverMainTrips();
  }

  filterDriverMainTrips() {
    if (this.isSorting) {
      this.filteredTrips.sort((a, b) => (a.priority || 0) - (b.priority || 0));
      Object.values(this.filteredCompatibleTrips).forEach((value: any) => {
        value.trips.sort((a, b) => (a.priority || 0) - (b.priority || 0));
      });
    } else {
      this.filteredTrips.sort((a, b) => <any>moment(a.scheduleTime) - <any>moment(b.scheduleTime));
      Object.values(this.filteredCompatibleTrips).forEach((value: any) => {
        value.trips.sort((a, b) => <any>moment(a.scheduleTime) - <any>moment(b.scheduleTime));
      });
    }
  }

  filterTrips() {
    const hasServiceAreaFilter = this.selectedServiceArea && this.selectedServiceArea.length;
    const hasStationManagerFilter = this.selectedStationManager && this.selectedStationManager.length;
    const hasDriverFilter = this.selectedDrivers && this.selectedDrivers.length;

    // Filter trips
    if (hasServiceAreaFilter) {
      this.filteredTrips = this.trips.filter(trip =>
        this.selectedServiceArea.includes(trip.serviceArea)
      );
    } else {
      this.filteredTrips = [...this.trips];
    }

    // Filter compatible trips
    this.filteredCompatibleTrips = {};
    Object.entries(this.compatibleTrips).forEach(([driverId, value]: [string, any]) => {
      const driver = value.driver;

      const isStationManagerMatch = !hasStationManagerFilter || this.selectedStationManager.includes(driver.stationManager);
      if (!isStationManagerMatch) {
         this.selectedDriverDetails = null;
         this.selectedDriverTrips = [];
        return
      };

      const isDriverMatch = !hasDriverFilter || this.selectedDrivers.includes(driver._id)
      if (!isDriverMatch) {
      this.selectedDriverDetails = null;
      this.selectedDriverTrips = [];
        return;
      };

      let filteredTrips = [...value.trips];

      if (hasServiceAreaFilter) {
        filteredTrips = filteredTrips.filter(trip =>
          this.selectedServiceArea.includes(trip.serviceArea)
        );
      }

      // if (filteredTrips.length > 0) {
      //   this.filteredCompatibleTrips[driverId] = {
      //     ...value,
      //     trips: filteredTrips
      //   };
      // }
      this.filteredCompatibleTrips[driverId] = {
        ...value,
        trips: filteredTrips
      };
    });

    // Optionally filter drivers list if needed
    if (hasStationManagerFilter) {
      this.filteredDrivers = this.drivers.filter(driver =>
        this.selectedStationManager.includes(driver.stationManager)
      );
    } else {
      this.filteredDrivers = [...this.drivers];
    }

    this.checkPossibility();
  }
  processBucket(apiResponse) {
    this.filterTrips();

  }

  toggleTimer() {
    this.isTimerEnabled = !this.isTimerEnabled;
    if (this.isTimerEnabled) {
      this.getTripsEmit();
    } else {
      this.timer.init();
    }
  }
  onTimerComplete(): void {
    this.timer.init();
    this.getTripsEmit();
  }

  showFilterLoad() {
    this.showSlideFilterLoad = !this.showSlideFilterLoad;
  }

  closeFilterLoad() {
    this.showSlideFilterLoad = false;
  }

  sortMethod(a, b) {
    return a.value.driver.displayName - b.value.driver.displayName
  }

  getGapHours(tripOne: any, tripTwo: any): number {
    if (!tripOne || !tripOne.appointmentTime || !tripTwo || !tripTwo.scheduleTime) return 0;
    const diff = moment(tripTwo.scheduleTime).diff(moment(tripOne.appointmentTime), 'hours', true);
    return diff > 0 ? Math.floor(diff) : 0;
  }

  getIconRange(count: number): number[] {
    return Array.from({ length: count });
  }

  getMarkeBall(assign, isPickup) {
    let icon = isPickup ? 'assets/images/map/origin_circle.png' : 'assets/images/map/destination_circle.png'
    if (assign.jobStatus === 'finished' || assign.jobStatus === 'cancelled') {
      icon = 'assets/images/map/finished_circle.png';
    }

    return icon;
  }

  selectDriverForMap(evt){
    if(this.selectedDriverDetails && this.selectedDriverDetails._id === evt){
      this.selectedDriverDetails = null;
      this.selectedDriverTrips = [];
      return;
    }
    if (evt && this.filteredCompatibleTrips[evt] && this.filteredCompatibleTrips[evt].trips && this.filteredCompatibleTrips[evt].trips.length){
      this.selectedDriverDetails = this.preDrivers[evt]
      this.selectedDriverTrips = this.filteredCompatibleTrips[evt].trips
      this.updateBounds();
    }else{
      this.selectedDriverDetails = null;
      this.selectedDriverTrips = [];
    }
  }

  updateBounds() {
    if (!this.googleMap || this.selectedDriverTrips.length === 0) return;
    const bounds = new google.maps.LatLngBounds();
    this.selectedDriverTrips.forEach(trip => {
      bounds.extend({ lat: trip.jobOriginLatitude, lng: trip.jobOriginLongitude });
      bounds.extend({ lat: trip.jobDestinationLatitude, lng: trip.jobDestinationLongitude });
    });
    if (this.selectedDriverDetails && this.selectedDriverDetails.startingPointAddress) {
      bounds.extend({ 
        lat: this.selectedDriverDetails.startingPointAddress.latitude, 
        lng: this.selectedDriverDetails.startingPointAddress.longitude 
      });
    }
    this.googleMap.fitBounds(bounds);
  }

  onMapReady(map: google.maps.Map) {
    this.updateBounds();
  }




}
